$(document).ready(()=>{

  $('.quick_question').on('click',function(){
    $(this).toggleClass('active')
    $(this).next().slideToggle()
  })
  
})


// document.addEventListener('DOMContentLoaded', function() {
//   document.querySelectorAll(".faq1_accordion").forEach((faq_item) =>{
//     faq_item.querySelector('.quick_question').addEventListener("click",function(e){
      
//     })
//   })
// })